export default __webpack_public_path__ + "static/media/pic1.ea8d81c0.jpg";